export const NAVY   = '#1B2B5E';
export const NAVY_D = '#111D3F';
export const GOLD   = '#F0A500';
export const G50    = '#F8F9FC';
export const G100   = '#EEF0F6';
export const G200   = '#E5E7EB';
export const G300   = '#C2C7D9';
export const G500   = '#6B7280';
export const G700   = '#374151';
